import {Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {FormControl} from '@angular/forms';


export class ButtonConfig {
    enable?: boolean;
    text?: string;
    icon?: string;
    label?: string;
    color?: string;
    id?: string;
    class?: string;
}

export class FilterConfig {
    enable?: boolean;
    filterOptions?: string[];
    defaultOption?: string;
    filterHint?: string;
}

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss']
})
@Injectable({
    providedIn: 'root'
})
export class AutocompleteComponent implements OnInit {
    @Input() searchName: string;
    @Input() label: string;
    @Input() hint: string;
    @Input() page: number;
    @Input() defaultValue = '';
    @Input() doAutofocus = true;
    @Input() clearInputOnSelect = true;
    inputValue = '';
    @Output() autocompleteInput: EventEmitter<any> = new EventEmitter<any>();
    @Output() selection: EventEmitter<any> = new EventEmitter<any>();
    @Output() filterChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() loadRequest: EventEmitter<any> = new EventEmitter<any>();
    @Output() addRequest: EventEmitter<any> = new EventEmitter<any>();
    @Input() clearRequest: EventEmitter<any> = new EventEmitter<any>();
    @Input() options: any[];
    @Input() objects: any[];
    @Input() buttonConfig: ButtonConfig;
    @Input() filterConfig: FilterConfig;
    @Input() disabled = false;
    @Input() debounceTime = 750;
    @ViewChild('autocomplete', {static: true}) selectElem: MatAutocomplete;
    @ViewChild('searchInput', {static: true}) searchInput;
    @ViewChild(MatAutocompleteTrigger, {read: MatAutocompleteTrigger}) inputAutocomplete: MatAutocompleteTrigger;
    filterControl: FormControl;
    top = 460;

    constructor() {
        this.filterControl = new FormControl('');
    }

    // eslint says it won't trigger this, but it seems to do it anyway so ignoring unless it causes problems
    // eslint-disable-next-line @angular-eslint/contextual-lifecycle
    ngOnInit() {
        if (this.defaultValue !== '') {
            this.inputValue = this.defaultValue;
        }
        this.selectElem.opened.subscribe(() => {
            /*do not delete, removes error*/
        });
        if (!this.buttonConfig) {
            this.buttonConfig = new ButtonConfig();
        }
        if (!this.filterConfig) {
            this.filterConfig = new FilterConfig();
        }
    }

    change() {
        this.page = 1;
        this.autocompleteInput.emit(this.inputValue);
        if (this.inputValue.length > 1) {
            this.selectElem.panel?.nativeElement.addEventListener('scroll', event => this.onScroll(event));
        }
    }

    addClick($event) {
        this.addRequest.emit($event);
        this.clear()
    }

    selected($event) {
        this.selection.emit($event);
        if (this.clearInputOnSelect) {
            this.clear();
        }
    }

    filterChanged($event) {
        this.filterChange.emit($event);
        setTimeout(() => {
            this.inputAutocomplete.openPanel();
        }, 0)
        this.clear();
    }

    clear() {
        setTimeout(() => {
            this.inputValue = '';
            this.options = [];
        }, 1000)

    }

    onScroll(event: any) {
        if (event.currentTarget.scrollTop < 460) {
            this.top = 460;
        }
        if (event.currentTarget.scrollTop > this.top) {
            this.top = this.top + 460;
            // Call pageable endpoint here, with a higher limitCount to get more values
            this.loadRequest.emit(this.page + 1);
        }
    }
}
